import { Tabs as TabsPrimitive } from '@base-ui/react/tabs';

import { cn } from '@/lib/utils';

export type TabsContentProps = TabsPrimitive.Panel.Props;

const TabsContent = ({ className, ...props }: TabsContentProps) => {
  return (
    <TabsPrimitive.Panel
      data-slot="tabs-content"
      className={cn('flex-1 text-sm outline-none', className)}
      {...props}
    />
  );
};

export default TabsContent;
